// extracted by mini-css-extract-plugin
export default {"container":"EmailSummaryInfo_container__6fAkP","infoText":"EmailSummaryInfo_infoText__uhdrs","infoValue":"EmailSummaryInfo_infoValue__VyQas"};